class DescriptionCollapse extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.description-collapse-content');
    this.button = this.querySelector('[data-description-toggle]');
    this.overlay = this.querySelector('.description-collapse-overlay');

    if (!this.content || !this.button) return;

    this.button.addEventListener('click', () => this.toggle());

    // Observe changes in visibility / size (such as when the collapsible tab opens)
    this.observer = new ResizeObserver(() => {
      // Only run checkHeight if the element is actually visible (height > 0)
      if (this.content.offsetHeight > 0) {
        this.checkHeight();
      }
    });
    this.observer.observe(this.content);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  checkHeight() {
    if (this.classList.contains('is-expanded')) {
      return;
    }
    const scrollHeight = this.content.scrollHeight;
    if (scrollHeight > 200) {
      this.button.style.display = 'inline-block';
      if (this.overlay) this.overlay.style.display = 'block';
      this.content.style.maxHeight = '200px';
    } else {
      this.button.style.display = 'none';
      if (this.overlay) this.overlay.style.display = 'none';
      this.content.style.maxHeight = 'none';
    }
  }

  toggle() {
    const isExpanded = this.classList.contains('is-expanded');
    const showMoreText = this.button.getAttribute('data-show-more-text') || 'Show more';
    const showLessText = this.button.getAttribute('data-show-less-text') || 'Show less';
    if (isExpanded) {
      this.content.style.maxHeight = '200px';
      this.classList.remove('is-expanded');
      this.button.textContent = showMoreText;
      
      // Smooth scroll back to the top of the collapsible tab parent if it went off screen
      const collapsibleTab = this.closest('collapsible-tab');
      if (collapsibleTab) {
        collapsibleTab.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    } else {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.classList.add('is-expanded');
      this.button.textContent = showLessText;
    }
  }
}

if (!customElements.get('description-collapse')) {
  customElements.define('description-collapse', DescriptionCollapse);
}
